//product card quick add to cart popup opens
function quickAddToCart() {
  const cartUpSellButton = document.querySelectorAll('.card-upsell-button');
  cartUpSellButton.forEach((quickBuyButton) => {
    quickBuyButton.addEventListener('click', (event) => {
      event.preventDefault();
      if (quickBuyButton.classList.contains('desktop-buy-button')) {
        const buyPopover = document.querySelector('buy-popover.card-upsell-popover');
        const productUrl = quickBuyButton.getAttribute('data-href');
        document.querySelector('.popup-overlay').classList.add('popup-background-shadow')
        // call fetch call function
        buyPopover.setAttribute('open', '');
        fetchPdpData(productUrl);
      }
    })
  })
}
quickAddToCart();
document.addEventListener('quick-add', quickAddToCart);


class CartUpsellRecommendations extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.cartUpsell();
  }

  async cartUpsell() {
    document.querySelector("cart-upsell-recommendations").innerHTML = "";
    let productIds = document.querySelector("cart-upsell-recommendations").getAttribute("data-product-id").split(",");
    let collectionHandles = document.querySelector("cart-upsell-recommendations").getAttribute("data-collection").split(",");


    const urls = productIds.map(id => `/recommendations/products?product_id=${id}&intent=complementary&section_id=upsell-recommendations`);
    const urls2 = collectionHandles.filter(handle => handle).map(handle => `/collections/${handle}?section_id`);
    const responses = await Promise.all(urls.map(url => fetch(url)));
    const responses2 = await Promise.all(urls2.map(url => fetch(url)));
    let hasRecommendation = false;

    for (let i = 0; i < responses.length; i++) {
        const response = responses[i];
        const text = response.status == 200 ? await response.text() : "null";
        const html = document.createElement('div');
        html.innerHTML = text;
        if(html.querySelector('#shopify-section-upsell-recommendations').innerHTML.trim() !== '') {
            hasRecommendation = true;
            this.makeMarkupHtml(html,"app");
            break;
        } 
        else if (responses2[i] != undefined && responses2[i].status == 200) {
            const res = responses2[i];
            const text2 = await res.text();
            const html2 = document.createElement('div');
            html2.innerHTML = text2;
            if (html2.innerHTML.trim() !== '') {
                this.makeMarkupHtml(html2,"collection");
                break;
            }
        }
    }
  }


  makeMarkupHtml(html,productOrigin) {
    let productIds = [];
    document.querySelectorAll("cart-upsell-recommendations .cart-upsell-item[data-product-id]").forEach((upsell)=>{
      let product_id = upsell.getAttribute("data-product-id");
      productIds.push(product_id);
      html.querySelector(`.shopify-section .cart-upsell-item[data-product-id='${product_id}']`)?.remove();
    });
    const metafieldData = html.querySelector('#collection-products')
    let upsellData = html.querySelector(".shopify-section").innerHTML;
    if (metafieldData) {
      upsellData = html.querySelector("#collection-products").innerHTML;
    }
    
    
    document.querySelector("cart-upsell-recommendations").insertAdjacentHTML('afterbegin', upsellData);

    if (document.querySelector("cart-upsell-recommendations").innerHTML == "") {
      document.querySelector(".cart_upsell_main_container").style.display = "none";
    } else {
      document.querySelector(".cart_upsell_main_container").style.display = "block";
      this.initflickity()
      const flickityInstance = Flickity.data(document.querySelector('cart-upsell-recommendations'));
      if (flickityInstance) {
        // Flickity is already initialized, destroy it
        flickityInstance.destroy();
      }
      // Initialize Flickity again
      this.initflickity();
    }

    this.handleAddPopEvent();
  }

  handleAddPopEvent() {
    // cart upsell quick buy button
    const cartUpsellButton = this.querySelectorAll('.card-upsell .card-upsell-button button');

    cartUpsellButton.forEach((quickBuyButton) => {
      quickBuyButton.addEventListener('click', (event) => {
        event.preventDefault();
        if (quickBuyButton.classList.contains('desktop-buy-button')) {
          const buyPopover = document.querySelector('buy-popover.card-upsell-popover');
          const productUrl = quickBuyButton.getAttribute('data-href');
          document.querySelector('.popup-overlay').classList.add('popup-background-shadow')
          // call fetch call function 
          buyPopover.setAttribute('open', '');
          fetchPdpData(productUrl);
        }
      })
    })
  }

  initflickity() {
    const buyPopover = document.querySelector('buy-popover.card-upsell-popover');
    const cartDrawer = document.querySelector('cart-drawer');
    // Store the original open method
    const originalOpen = cartDrawer.open.bind(cartDrawer);
    // Override the open method with our custom function
    cartDrawer.open = function () {
      // Call the original open method if it exists
      if (originalOpen) {
        originalOpen();
      }
      setTimeout(() => {
        var elem = document.querySelector('cart-upsell-recommendations');
        document.querySelector(".shimmer-upsell-card-main").style.display = "none";
        elem.style.display = "block";
        var flkty = new Flickity(elem, {
          // options
          cellAlign: 'left',
          prevNextButtons: true,
          cellSpacing: 30,
          freeScroll: true,
          pageDots: false,
          adaptiveHeight: true
        });
        setTimeout(() => {
          flkty.resize();
      }, 100);
        // Hide the arrows if only one product is there
        if (document.querySelectorAll(".card-upsell")?.length <= 1) {
          document.querySelector("cart-upsell-recommendations .flickity-prev-next-button.previous").style.display = "none";
          document.querySelector("cart-upsell-recommendations .flickity-prev-next-button.next").style.display = "none";
        }
      }, 1000);
    };
    // Call the original open method immediately if needed
    if ((cartDrawer.classList.contains('active')) || buyPopover.hasAttribute('open')) {
      cartDrawer.open();
    }
  }
}
customElements.define('cart-upsell-recommendations', CartUpsellRecommendations);